import React from "react";
import "./Project.css";
import Logo from "../../img/Logo.png";
import { useInView } from "react-intersection-observer";

function Project() {
  const { ref: r1, inView: view1 } = useInView({ threshold: 0 });
  const { ref: r2, inView: view2 } = useInView({ threshold: 0 });

  return (
    <div className="project" id="project">
      {/* <h2>Projects</h2> */}
      <div className="project_design">
        <div ref={r2} className="project_details">
          <a
            href="https://dukaan-j5uchhi77-atulyajaiswal.vercel.app/"
            target="_blank"
            rel="noreferrer">
            <img
              src="https://i0.wp.com/therumzzline.com/wp-content/uploads/2021/03/Ecommerce-site-logo-Online-Shopping-N-Shop-Logo-copy.jpg?resize=1400%2C700&ssl=1"
              alt="Spotify"
            />
          </a>
          <div className="project_details_heading">
            <a
              href="https://dukaan-j5uchhi77-atulyajaiswal.vercel.app/"
              target="_blank"
              rel="noreferrer">
              <h4>Dukaan</h4>
            </a>
            <ul class={view2 ? "animate__animated animate__bounceInRight" : ""}>
              <li> User can shop items according to their need</li>
              <li>
                {" "}
                Complete admin dashboard with track of total earning, total
                products sold, complete user activity and also order tracking
              </li>
              <li>Tech Stack - MERN, Redux</li>
              <li>Cloudinary for image uploads</li>
            </ul>
          </div>
        </div>
        <div ref={r1} className="project_details">
          <a
            href="https://socialepics-cbkg3rmm3-atulyajaiswal.vercel.app/"
            target="_blank"
            rel="noreferrer">
            <img src={Logo} alt="Social-Epics" />
          </a>
          <div className="project_details_heading">
            <a
              href="https://socialepics-cbkg3rmm3-atulyajaiswal.vercel.app/"
              target="_blank"
              rel="noreferrer">
              <h4>Social Epics</h4>
            </a>
            <ul class={view1 ? "animate__animated animate__bounceInRight" : ""}>
              <li>
                Creating anonymous user id so that they can anonymously post
                without hesitation
              </li>
              <li>Complete authentication using email and phone number</li>
              <li>
                Top 5 topics discussed in last 5 days are displayed as Hot
                Topics
              </li>
              <li>
                Scheduling of post can also be done to post it at desired time
              </li>
              <li>Admin can control all activity of users</li>
              <li>Tech Stack - MERN, Redux, Firebase</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
